// extracted by css-extract-rspack-plugin
export default {"title":"Title-module__title__kuAeDQO"};